// Content for the "Custom Website" service offering.
// Hardcoded (no Contentful) and shared by the /custom-websites page
// and the homepage teaser.

export const CONTACT_EMAIL = "dynamicwebpartners@gmail.com"

export const included = [
  {
    title: "Custom design",
    body: "Designed around your brand and goals from a blank canvas — never a template.",
  },
  {
    title: "Fully responsive",
    body: "Looks effortless on phone, tablet, and desktop — every screen, every time.",
  },
  {
    title: "Contact / signup form",
    body: "A built-in form that emails submissions straight to your inbox.",
  },
  {
    title: "Social integration",
    body: "Instagram, YouTube, and wherever else your audience already follows you.",
  },
  {
    title: "Speed & polish",
    body: "Fast, modern, and built to make a strong first impression.",
  },
  {
    title: "Up to 3 rounds of revisions",
    body: "We refine it together until every detail feels right.",
  },
]

export const process = [
  {
    title: "Connect",
    body: "Share your vision, inspiration, and assets. We get to know you and your goals.",
  },
  {
    title: "Design & Build",
    body: "We craft your site from scratch — custom-built around your brand.",
  },
  {
    title: "Refine",
    body: "Up to three rounds of revisions to get every detail exactly right.",
  },
  {
    title: "Launch",
    body: "We ship it to the world — fast, polished, and ready to impress.",
  },
]

export const needs = [
  "A few inspiration sites or styles you love",
  "Your assets — photos, images, and video",
  "Your brand — logo and social links",
  "Any copy or words you’d like included",
]

// The flat base fee. Everything in `included` ships with it.
export const baseFee = {
  title: "Custom website design & build",
  price: "$1,500",
  note: "flat project fee",
  body: "Everything above, built from scratch — including up to 3 rounds of revisions. From here, add only the capabilities your project needs.",
}

// Optional add-on capabilities. Priced per project — inquire for a quote.
export const addOns = [
  {
    title: "Self-managed content (CMS)",
    body: "Edit your own text, images, and content anytime — no developer needed.",
  },
  {
    title: "API integrations",
    body: "Pull in live data and connect the external tools your business runs on.",
  },
  {
    title: "Third-party services",
    body: "Booking, scheduling, payments, email & CRM, newsletters, and more.",
  },
  {
    title: "Advanced forms & automation",
    body: "Route submissions to your inbox, CRM, or Slack — with autoresponders.",
  },
  {
    title: "Location & maps",
    body: "Interactive maps, store locators, and location-aware content.",
  },
  {
    title: "Social feeds & embeds",
    body: "Live Instagram, YouTube, TikTok, and Spotify built right in.",
  },
  {
    title: "E-commerce & payments",
    body: "Sell products, services, merch, or tickets directly from your site.",
  },
  {
    title: "Analytics & SEO",
    body: "Tracking, search optimisation, and performance tuning that gets you found.",
  },
  {
    title: "Extra revision rounds",
    body: "More back-and-forth beyond the three rounds included in the build.",
  },
  {
    title: "Domain & hosting setup",
    body: "We’ll handle the technical setup so you don’t have to think about it.",
  },
]

export const faqs = [
  {
    question: "What if I don’t have my content ready?",
    answer:
      "That’s completely fine. Bring what you have and we’ll shape the rest together as we go — you don’t need it all figured out to get started.",
  },
  {
    question: "How is pricing worked out?",
    answer:
      "Every project starts from a flat build fee, then you add only the capabilities you need. Tell us what you’re after and we’ll put together a tailored quote — no guesswork, no surprises.",
  },
  {
    question: "How many revisions do I get?",
    answer:
      "Up to 3 rounds are included in the build. Need more? Extra revision rounds are available as an add-on.",
  },
  {
    question: "Can I update the site myself later?",
    answer:
      "Yes — self-managed content is an optional add-on. With it you can edit your text, images, and content anytime, with no developer needed.",
  },
  {
    question: "Do I need a domain name?",
    answer:
      "A domain isn’t included, but they’re inexpensive (around $12–20/yr). We recommend Squarespace for simplicity, though any registrar works — and we can set it all up for you as an add-on.",
  },
]
